import React, { useMemo } from 'react';
import { TripPlannerPromoHero as SharedTripPlannerPromoHero } from 'alakai-aloha-shared/public-ui';
import { getRuntimeSiteContext } from '../../lib/siteContext';
import { trackEvent } from '../../utils/analytics';

const TripPlannerPromoHero = ({ pageType = 'restaurant', className = '' }) => {
  const { island } = useMemo(() => getRuntimeSiteContext(), []);

  return (
    <SharedTripPlannerPromoHero
      pageType={pageType}
      island={island}
      className={className}
      onQuizClick={() => {
        trackEvent('quiz_cta_click', {
          source: `${pageType}_profile_promo_hero`,
          cta: 'primary',
        });
      }}
      onInterviewClick={() => {
        trackEvent('interview_cta_click', {
          source: `${pageType}_profile_promo_hero`,
          cta: 'secondary',
        });
      }}
    />
  );
};

export default TripPlannerPromoHero;
